import {
    Component,
    OnInit
} from '@angular/core';
import {
    FormsModule,
    ReactiveFormsModule
} from '@angular/forms';
import {
    ActivatedRoute,
    RouterLink
} from '@angular/router';
import { MessageService } from 'primeng/api';
import { Button } from 'primeng/button';
import { InputText } from 'primeng/inputtext';
import {
    Tab,
    TabList,
    Tabs
} from 'primeng/tabs';

import { AppLoaderComponent } from '@/components';
import {
    DistrictDocumentType,
    RateListingPreset
} from '@/enums';
import { DistrictMapping } from '@/interfaces';
import {
    DistrictDocumentListingComponent,
    RateListingComponent
} from '@/pages';
import { ValueOrPipe } from '@/pipes';
import {
    DistrictMappingsService,
    DistrictsService
} from '@/service';


@Component({
    selector: 'app-district-details',
    templateUrl: 'view.component.html',
    styleUrls: ['./view.component.scss'],
    imports: [
        Button,
        RouterLink,
        AppLoaderComponent,
        ValueOrPipe,
        Tabs,
        TabList,
        Tab,
        RateListingComponent,
        DistrictDocumentListingComponent,
        FormsModule,
        InputText,
        ReactiveFormsModule
    ],
    standalone: true
})
export class DistrictViewComponent implements OnInit {

    loading = false;
    id!: string;
    districtMapping: DistrictMapping | null = null;
    tabs: {
        label: string,
        icon: string,
        type?: DistrictDocumentType,
        groupBy?: string,
        preset?: RateListingPreset
    }[] = [
        { label: 'Agendas', icon: 'pi pi-calendar', type: DistrictDocumentType.AGENDA },
        { label: 'Contracts', icon: 'pi pi-file', type: DistrictDocumentType.CONTRACT },
        { label: 'Rates', icon: 'pi pi-dollar' },
        { label: 'Agencies', icon: 'pi pi-building', groupBy: 'competitor_id', preset: RateListingPreset.BY_COMPETITOR },
    ];
    activeTabLabel = 'Agendas';
    editingLink: string | undefined = undefined;
    editingLinkMode = false;

    constructor(
        private service: DistrictMappingsService,
        private districtsService: DistrictsService,
        private route: ActivatedRoute,
        private messageService: MessageService,
    ) {
    }

    get activeTab(): any {
        return this.tabs.find(e => e.label === this.activeTabLabel);
    }

    ngOnInit(): void {
        this.id = this.route.snapshot.params['district_mapping_id'];
        if (this.id) {
            this.view();
        }
    }

    view(): void {
        this.loading = true;
        this.service.view(this.id).subscribe({
            next: (data: DistrictMapping) => {
                this.districtMapping = data;
                this.loading = false;
            },
            error: (err) => {
                this.loading = false;
                if (err.error?.error) {
                    this.messageService.add({
                        severity: 'error',
                        detail: err.error?.error
                    });
                }
            }
        });
    }

    openEditMode(): void {
        this.editingLinkMode = true;
        this.editingLink = this.districtMapping?.mapped_district?.agenda_url;
    }

    editDistrict(): void {
        if (!this.districtMapping) {
            return;
        }
        this.loading = true;
        this.districtsService.edit(this.districtMapping?.mapped_district_id, { link: this.editingLink }).subscribe({
            next: () => {
                if (this.districtMapping?.mapped_district) {
                    this.districtMapping.mapped_district.agenda_url = this.editingLink;
                }
                this.messageService.add({
                    severity: 'success',
                    detail: 'District link has been updated successfully.'
                });
                this.editingLinkMode = false;
                this.loading = false;
            },
            error: (err: any) => {
                if (err.error?.error) {
                    this.messageService.add({
                        severity: 'error',
                        detail: err.error?.error
                    });
                }
                this.loading = false;
            },
        });
    }
}
